import { Component, OnInit, Input } from '@angular/core';
import { ReportService } from '@app/core';

@Component({
  selector: 'app-visitorareachart',
  templateUrl: './visitorareachart.component.html',
  styleUrls: ['./visitorareachart.component.scss']
})
export class VisitorareachartComponent implements OnInit {
  
  @Input() filterData: any;//{prop1: string, prop2: string};

  columnNames = ['This Month', "User Registration","First Login", "Login", "Profile Update", "Preference Update", "Statement Download"];
  data:any;

  data1 = [
    ['Jan',  1000,      400, 100],
    ['Feb',  1170,      460, 1000],
    ['Mar',  660,       1120, 500],
    ['Apr',  1030,      540, 300],
    ['May',  1000,      400, 100],
    ['Jun',  1170,      460, 1000],
    ['Jul',  660,       1120, 500],
    ['Aug',  1030,      540, 300],
    ['Sep',  1030,      540, 300],
    ['Oct',  1030,      540, 300],
    ['Nov',  1030,      540, 300],
    ['Dec',  1030,      540, 300]
  ];

  data2 = [
    ['Jan',  20,      22, 55],
    ['Feb',  12,      22, 214],
    ['Mar',  3,       234, 444],
    ['Apr',  10330,      543, 1332],
    ['May',  103300,      400, 322],
    ['Jun',  123,      460, 1000],
    ['Jul',  45,       435, 500],
    ['Aug',  54,      345, 300],
    ['Sep',  322,      540, 300],
    ['Oct',  222,      540, 332],
    ['Nov',  11,      540, 44],
    ['Dec',  10320,      540, 444]
  ];

  options = {
    curveType: 'function',
    legend: { position: 'bottom' }
  };

  constructor(
    private reportService : ReportService
  ) { }

  ngOnChanges(){
    console.log(this.filterData);
    // if(this.childData=="1 week"){
    //   this.data=this.data2;
    // }else{
    //   this.data=this.data1;
    // }
    this.getVisitorData(this.filterData);


  }
  ngOnInit() {
    // this.data=this.data1;
    console.log(this.filterData);
    this.getVisitorData("Today");
   
  }

  getVisitorData(filter:string){
    this.reportService.getVisitorAnalyticsData(filter).subscribe(
      response => {
        console.log(response.data);
        this.data = response.data
      },
      error => {
      }
    )
  }
}
